export enum DistanceUnit {
  METRIC = "METRIC",
  IMPERIAL = "IMPERIAL",
}

export enum DistanceValueUnit {
  CM,
    METERS,
    METERS_SQUARED,
    METERS_SQUARED_PER_HOUR
}